"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The SorteKurs model module.
 * @module model/SorteKurs
 * @version 1.0.44
 */
var SorteKurs = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SorteKurs</code>.
   * Kurs einer Sorte
   * @alias module:model/SorteKurs
   * @param kennziffer {String} Kennziffer der Sorte
   * @param isoCode {String} 3 Buchstabiger ISO Ländercode
   * @param bezeichnung {String} Bezeichnung der Sorte mit Land und Namen der Sorte
   * @param kurs {Number} aktueller Kurs der Sorte
   * @param einheit {String} kleinste Schrittgröße der Sorte 
   * @param innenProvision {Number} mögliche Provision für Mitarbeiter
   * @param kleinsteStueckelung {Number} kleinste momentan verfügbare Stückelung
   * @param stueckelungen {String} Verfügbare Stückelungsgrößen. Beispiel: \"5,10,20,100\"
   */
  function SorteKurs(kennziffer, isoCode, bezeichnung, kurs, einheit, innenProvision, kleinsteStueckelung, stueckelungen) {
    _classCallCheck(this, SorteKurs);
    SorteKurs.initialize(this, kennziffer, isoCode, bezeichnung, kurs, einheit, innenProvision, kleinsteStueckelung, stueckelungen);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(SorteKurs, null, [{
    key: "initialize",
    value: function initialize(obj, kennziffer, isoCode, bezeichnung, kurs, einheit, innenProvision, kleinsteStueckelung, stueckelungen) {
      obj['kennziffer'] = kennziffer;
      obj['isoCode'] = isoCode;
      obj['bezeichnung'] = bezeichnung;
      obj['kurs'] = kurs;
      obj['einheit'] = einheit;
      obj['innen_provision'] = innenProvision;
      obj['kleinsteStueckelung'] = kleinsteStueckelung;
      obj['stueckelungen'] = stueckelungen;
    }

    /**
     * Constructs a <code>SorteKurs</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SorteKurs} obj Optional instance to populate.
     * @return {module:model/SorteKurs} The populated <code>SorteKurs</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SorteKurs();
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'String');
        }
        if (data.hasOwnProperty('isoCode')) {
          obj['isoCode'] = _ApiClient.default.convertToType(data['isoCode'], 'String');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
        if (data.hasOwnProperty('kurs')) {
          obj['kurs'] = _ApiClient.default.convertToType(data['kurs'], 'Number');
        }
        if (data.hasOwnProperty('einheit')) {
          obj['einheit'] = _ApiClient.default.convertToType(data['einheit'], 'String');
        }
        if (data.hasOwnProperty('innen_provision')) {
          obj['innen_provision'] = _ApiClient.default.convertToType(data['innen_provision'], 'Number');
        }
        if (data.hasOwnProperty('kleinsteStueckelung')) {
          obj['kleinsteStueckelung'] = _ApiClient.default.convertToType(data['kleinsteStueckelung'], 'Number');
        }
        if (data.hasOwnProperty('stueckelungen')) {
          obj['stueckelungen'] = _ApiClient.default.convertToType(data['stueckelungen'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SorteKurs</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SorteKurs</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(SorteKurs.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['kennziffer'] && !(typeof data['kennziffer'] === 'string' || data['kennziffer'] instanceof String)) {
        throw new Error("Expected the field `kennziffer` to be a primitive type in the JSON string but got " + data['kennziffer']);
      }
      // ensure the json data is a string
      if (data['isoCode'] && !(typeof data['isoCode'] === 'string' || data['isoCode'] instanceof String)) {
        throw new Error("Expected the field `isoCode` to be a primitive type in the JSON string but got " + data['isoCode']);
      }
      // ensure the json data is a string
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      // ensure the json data is a string
      if (data['einheit'] && !(typeof data['einheit'] === 'string' || data['einheit'] instanceof String)) {
        throw new Error("Expected the field `einheit` to be a primitive type in the JSON string but got " + data['einheit']);
      }
      // ensure the json data is a string
      if (data['stueckelungen'] && !(typeof data['stueckelungen'] === 'string' || data['stueckelungen'] instanceof String)) {
        throw new Error("Expected the field `stueckelungen` to be a primitive type in the JSON string but got " + data['stueckelungen']);
      }
      return true;
    }
  }]);
}();
SorteKurs.RequiredProperties = ["kennziffer", "isoCode", "bezeichnung", "kurs", "einheit", "innen_provision", "kleinsteStueckelung", "stueckelungen"];

/**
 * Kennziffer der Sorte
 * @member {String} kennziffer
 */
SorteKurs.prototype['kennziffer'] = undefined;

/**
 * 3 Buchstabiger ISO Ländercode
 * @member {String} isoCode
 */
SorteKurs.prototype['isoCode'] = undefined;

/**
 * Bezeichnung der Sorte mit Land und Namen der Sorte
 * @member {String} bezeichnung
 */
SorteKurs.prototype['bezeichnung'] = undefined;

/**
 * aktueller Kurs der Sorte
 * @member {Number} kurs
 */
SorteKurs.prototype['kurs'] = undefined;

/**
 * kleinste Schrittgröße der Sorte 
 * @member {String} einheit
 */
SorteKurs.prototype['einheit'] = undefined;

/**
 * mögliche Provision für Mitarbeiter
 * @member {Number} innen_provision
 */
SorteKurs.prototype['innen_provision'] = undefined;

/**
 * kleinste momentan verfügbare Stückelung
 * @member {Number} kleinsteStueckelung
 */
SorteKurs.prototype['kleinsteStueckelung'] = undefined;

/**
 * Verfügbare Stückelungsgrößen. Beispiel: \"5,10,20,100\"
 * @member {String} stueckelungen
 */
SorteKurs.prototype['stueckelungen'] = undefined;
var _default = exports.default = SorteKurs;